/**
 * Main Element:
 * data-overlay="unique-key"
 * data-overlay-ignore-escape
 *
 * Buttons:
 * data-overlay-toggle="unique-key"
 * data-overlay-open="unique-key"
 * data-overlay-close="unique-key"
 *
 * CSS Classes Applied to Body:
 * overlay-unique-key-opening
 * overlay-unique-key-open
 * overlay-unique-key-closing
 * some-overlay-open
 *
 */

const openDuration = 10;
const closeDuration = 300;
const debugMode = true;


const log = message => debugMode && console.log(`[Overlay] ${message}`);

const state = { current: null };

const openTransition = overlayKey => new Promise(resolve => {
  document.body.classList.add(`overlay-${overlayKey}-opening`);
  // Reset scroll position once the overlay is visible (display set via opening class)
  requestAnimationFrame(() => {
    document.querySelectorAll(`[data-overlay="${overlayKey}"]`).forEach(el => {
      el.scrollTop = 0;
      el.querySelectorAll('*').forEach(child => {
        if (child.scrollTop) child.scrollTop = 0;
      });
    });
  });
  setTimeout(() => {
    document.body.classList.add(`overlay-${overlayKey}-open`, `some-overlay-open`);
    resolve();
  }, openDuration);
});

const closeTransition = overlayKey => new Promise(resolve => {
  document.body.classList.remove(`overlay-${overlayKey}-open`);
  document.body.classList.add(`overlay-${overlayKey}-closing`);
  setTimeout(() => {
    document.body.classList.remove(
      `overlay-${overlayKey}-closing`,
      `overlay-${overlayKey}-opening`,
      `some-overlay-open`
    );
    resolve();
  }, closeDuration);
});

document.querySelectorAll('[data-overlay]').forEach(overlay => {
  const key = overlay.getAttribute('data-overlay');
  const closeOnEscape = !overlay.hasAttribute('data-overlay-ignore-escape');

  const closeOverlay = async e => {
    e?.preventDefault();
    if (state.current !== key) return;
    log(`Closing overlay: ${key}`);
    await closeTransition(key);
    state.current = null;

    window.dispatchEvent(new CustomEvent('overlay:closed', { detail: { key, open: false } }));
  };

  const openOverlay = async e => {
    e?.preventDefault();
    if (state.current === key) return;

    // Close any open overlay first
    if (state.current) {
      log(`Auto-closing overlay: ${state.current}`);
      await closeTransition(state.current);
    }

    log(`Opening overlay: ${key}`);

    await openTransition(key);
    state.current = key;

    window.dispatchEvent(new CustomEvent('overlay:opened', { detail: { key, open: true } }));
  };

  const toggleOverlay = e => state.current === key ? closeOverlay(e) : openOverlay(e);

  document.querySelectorAll(`[data-overlay-toggle="${key}"]`).forEach(el =>
    el.addEventListener('click', toggleOverlay)
  );

  document.querySelectorAll(`[data-overlay-open="${key}"]`).forEach(el =>
    el.addEventListener('click', openOverlay)
  );

  [...document.querySelectorAll(`[data-overlay-close="${key}"]`),
    ...overlay.querySelectorAll('[data-overlay-close]')].forEach(el =>
    el.addEventListener('click', closeOverlay)
  );

  closeOnEscape && document.addEventListener('keydown', e =>
    state.current === key && e.key === 'Escape' && closeOverlay(e)
  );

  log(`Initialized overlay: ${key}`);
});

log('Overlay script loaded');
